<template>
  <div>
    <v-container fluid grid-list-xl pa-0>
      <v-layout wrap align-center>
        <v-flex xs12>
          <h1 class="content-title">Spice Money Agents</h1>
          <h2 class="content-sub-title">Get list of spice money agents</h2>
          <p>Select state and city to get list of agents</p>
        </v-flex>
        <v-flex xs12 sm6>
          <v-autocomplete
            :items="states"
            label="Select State"
            @change="onStateChange"
            solo
            persistent-hint
          ></v-autocomplete>
        </v-flex>

        <v-flex xs12 sm6>
          <v-autocomplete
            :items="cities"
            label="Select City"
            @change="onCityChange"
            persistent-hint
            solo
          ></v-autocomplete>
        </v-flex>

        <v-flex xs12 v-if="names.length!=0">
          <table>
            <tr>
              <th>List of Agents</th>
            </tr>
            <tr v-for="(name,index) in names" :key="index">
              <td>({{index+1}}) {{name}}</td>
            </tr>
          </table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 3px;
  overflow: hidden;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

table th {
  background: #4385f3;
  color: #fff;
  padding: 10px;
  text-align: left;
}
table td {
  padding: 10px;
  text-align: left;
}
table tr:nth-child(odd) td {
  background: #f2f2f2;
}
h3 {
  font-weight: normal;
  font-size: 18px;
  font-style: italic;
  padding-bottom: 20px;
}
.content-title {
  color: #ed1c24;
  font-size: 24px;
  font-weight: normal;
  margin: 0;
  padding: 0;
  text-transform: uppercase;
}
.content-sub-title {
  font-size: 32px;
  line-height: 32px;
  text-transform: uppercase;
  color: #293896;
  margin-bottom: 30px;
}
@media only screen and (max-width: 768px) {
  .content-title {
    font-size: 14px;
  }
  .content-sub-title {
    font-size: 16px;
    line-height: 16px;
  }

  h3 {
    font-size: 14px;
  }
}
</style>

<script>
import LocateAgents from "./LocateAgents.ts";
export default LocateAgents;
</script>